import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { TextCell } from "../TextCell";

export interface CustomTypeFieldCellProps {
  customTypeId?: string;
}

export const CustomTypeFieldCell = ({ customTypeId }: CustomTypeFieldCellProps) => {
  const { t } = useTranslation("contacts");

  const customTypeQuery = useTellescopeQuery({
    model: "enduser_custom_types",
    method: "getOne",
    request: customTypeId ?? "",
    enabled: !!customTypeId,
    crossQueryCacheSharing: true,
  });

  if (!customTypeId) return <TextCell className="text-muted-foreground">{t("No type")}</TextCell>;

  if (customTypeQuery.isLoading) return <TextCell className="text-muted-foreground">{t("Loading...")}</TextCell>;

  const title = customTypeQuery.data?.title;
  if (!title) return <TextCell className="text-muted-foreground">{t("Unknown type")}</TextCell>;

  return <TextCell>{title}</TextCell>;
};
